<template>
  <div>
    <!-- Modal/Update-Create component starts -->
    <create-modal :name="type" :fields="fields" v-if="fields" @save="createItem" />
    <!-- Modal/Update-Create component ends -->

    <div class="tab-content mt-20">
      <!-- table component start -->
      <Table
        :type="type"
        @deleteItem="deleteItem"
        @saveItem="updateItem"
        :fields="fields"
        :items="items"
        @loginAsUser="loginAsUser"
        @syncAdmin="syncAdminRole"
      />
      <div class="flex justify-center items-center my-50">
        <base-paginate
          :links="links"
          @onPageChange="onPageChange"
          :type="type"
          v-if="links.current_page"
        />
        <p class="font-bold mx-20">{{ $t('count') }} : {{ links.total }}</p>
      </div>
      <!-- table component end -->
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/EventBus';
import toastHandler from '@/utils/serverErrorsHandler';
import axiosConfig from '@/services/axios.config';
import addIcon from '@/assets/icons/svg/white-add.svg';
import BasePaginate from '@/components/base/BasePaginate.vue';
import getUser from '@/services/profile/user.service';
import Table from '@/components/admin/dashboard/Table.vue';
import CreateModal from '../../modals/CreateModal.vue';

export default {
  name: 'AdminPanel',
  data() {
    return {
      addIcon,
      links: {},
      currentPage: 1,
      items: [
        {
          id: 1,
          name: 'name',
          job: 'job',
        },
      ],
      fields: [],
      fieldsType: {
        users: ['avatar', 'name', 'mobile', 'job_position'],
        companies: ['logo', 'name', 'owner_name', 'owner_mobile', 'invitation_code'],
        platforms: ['name', 'latest_version', 'minimum_version', 'change_log'],
        // eslint-disable-next-line quote-props
        'serial-numbers': [
          'name',
          'serial_number',
          'company_name',
          'manufacture_date',
          'sale_date',
          'installation_date',
          'version',
          'superadmin_password',
          'warranty_end_date',
        ],
        logs: ['logo', 'name', 'mobile', 'created_date', 'device', 'ip', 'method', 'log_title_adminpanel'],
      },
    };
  },
  components: {
    Table,
    CreateModal,
    BasePaginate,
  },
  props: {
    type: {
      type: String,
      default: 'companies',
    },
    searchedText: {
      type: String,
      default: '',
    },
  },
  created() {
    this.getData(1);
    this.fields = this.fieldsType[this.type];
    EventBus.$on('AdminAddButton', () => {
      this.$store.dispatch('modal/open', 'create');
    });
  },
  watch: {
    searchedText() {
      this.getSearchedText(this.searchedText);
    },
  },
  methods: {
    getData(page) {
      let queries = '';
      switch (this.type) {
        case 'companies':
          queries = 'sortdesc[]=created_at&columns[]=name&columns[]=public_code&columns[]=owner_name';
          break;
        case 'users':
          queries = 'sortdesc[]=created_at&columns[]=name&columns[]=mobile&columns[]=email';
          break;
        case 'serial-numbers':
          queries = 'sortdesc[]=created_at&columns[]=name&columns[]=serial-number&columns[]=warranty_end_date&columns[]=sale_date&columns[]=installation_date&columns[]=version&columns[]=manufacture_date';
          break;
        case 'platforms':
          queries = 'sortdesc[]=created_at&columns[]=name&columns[]=minimum_version&columns[]=latest_version&columns[]=change_log';
          break;
        case 'logs':
          queries = 'sortdesc[]=created_at&columns[]=name&columns[]=mobile';
          break;
        default:
          break;
      }
      axiosConfig
        .get(
          `/admin/${this.type}?page=${page}&q=${this.searchedText}
&${queries}`,
        )
        .then((response) => {
          const result = response.data.data;
          if (this.type === 'companies') {
            const companiesData = [];
            result.map((singleCompany) => {
              const companyObject = {
                id: singleCompany.id,
                name: singleCompany.name,
                logo: singleCompany.logo,
                invitation_code: singleCompany.public_code,
                owner_name: singleCompany.owner?.name, // if owner exists get its name
                owner_mobile: singleCompany.owner?.mobile,
                owner_id: singleCompany.owner?.id,
              };
              companiesData.push(companyObject);
              return companiesData;
            });
            this.items = companiesData;
          } else if (this.type === 'logs') {
            const logsData = [];
            result.map((singleLog) => {
              const logObject = {
                mobile: singleLog?.user.mobile,
                name: singleLog?.user.name,
                logo: singleLog?.user.avatar,
                log_title_adminpanel: singleLog?.log_title,
                ip: singleLog?.ip,
                device: singleLog?.agent,
                created_date: singleLog?.created_at,
                method: singleLog?.method,
              };
              logsData.push(logObject);
              return logsData;
            });
            this.items = logsData;
          } else {
            this.items = result;
          }
          this.links = response.data.meta;
        });
    },
    loginAsUser(userId) {
      // eslint-disable-next-line no-restricted-globals, no-alert
      const confirmSubmit = confirm('Are you sure to login as owner?');
      if (confirmSubmit) {
        axiosConfig.post(`/admin/users/${userId}/login`).then((response) => {
          localStorage.setItem('superadmin_user', localStorage.getItem('user'));
          localStorage.setItem('superadmin_token', localStorage.getItem('token'));
          this.$store.commit('authentication/USER_DATA', response.data.data);
          this.$store.commit('authentication/LOGIN_SUCCUSS', response);
          localStorage.setItem('token', JSON.stringify(response.data.data.token));
          localStorage.removeItem('user');
          getUser();
          this.$router.push({ name: 'Dashboard', query: { active: 'dashboard' } });
        });
      }
    },
    syncAdminRole(userId) {
      this.$store.commit('loading/LOADING_HANDLER', true);
      axiosConfig
        .post(`/admin/${this.type}/${userId}/sync-super-admin-permission`)
        .then(() => {
          this.getData('users');
          this.$toast.success(this.$t('edited'));
          this.$store.commit('loading/LOADING_HANDLER', false);
        })
        .catch((error) => {
          this.$store.commit('loading/LOADING_HANDLER', false);
          toastHandler(error);
          throw error;
        });
    },
    getSearchedText(searchedText) {
      this.searchedText = searchedText;
      this.getData(this.currentPage);
    },
    deleteItem(itemId) {
      this.$store.commit('loading/LOADING_HANDLER', true);
      axiosConfig
        .delete(`/admin/${this.type}/${itemId}`)
        .then(() => {
          this.getData(this.currentPage);
          this.$store.commit('loading/LOADING_HANDLER', false);
          this.$toast.success(this.$t('deleted'));
        })
        .catch((error) => {
          this.$store.commit('loading/LOADING_HANDLER', false);
          toastHandler(error);
          throw error;
        });
      this.$store.dispatch('modal/close', 'delete');
    },
    updateItem(item) {
      if (item.logo) {
        // eslint-disable-next-line no-underscore-dangle, no-param-reassign
        item._method = 'PUT';
        // eslint-disable-next-line no-param-reassign
        item.logo = null;
      } else {
        // eslint-disable-next-line no-param-reassign
        item.avatar = null;
      }
      this.$store.commit('loading/LOADING_HANDLER', true);
      axiosConfig
        .put(`/admin/${this.type}/${item.id}`, { ...item })
        .then(() => {
          this.getData(this.currentPage);
          this.$store.commit('loading/LOADING_HANDLER', false);
          this.$toast.success(this.$t('edited'));
        })
        .catch((error) => {
          this.$store.commit('loading/LOADING_HANDLER', false);
          toastHandler(error);
          throw error;
        });
    },
    createItem(item) {
      this.$store.commit('loading/LOADING_HANDLER', true);
      const formData = new FormData();
      if (this.type === 'users') {
        formData.append('name', item.name);
        formData.append('mobile', item.mobile);
        formData.append('avatar', item.avatar || ''); // if item.avatar was undefined send '' instead
        formData.append('job_position', item.job_position);
        formData.append('country_code', item.country_code);
        axiosConfig
          .post(`/admin/${this.type}`, formData)
          .then(() => {
            this.getData(this.currentPage);
            this.$store.commit('loading/LOADING_HANDLER', false);
            this.$toast.success(this.$t('created'));
          })
          .catch((error) => {
            this.$store.commit('loading/LOADING_HANDLER', false);
            toastHandler(error);
            throw error;
          });
      } else {
        axiosConfig
          .post(`/admin/${this.type}`, { ...item })
          .then(() => {
            this.getData(this.currentPage);
            this.$store.commit('loading/LOADING_HANDLER', false);
            this.$toast.success(this.$t('created'));
          })
          .catch((error) => {
            this.$store.commit('loading/LOADING_HANDLER', false);
            toastHandler(error);
            throw error;
          });
      }
    },
    // eslint-disable-next-line no-unused-vars
    onPageChange(currentPageCount, type) {
      this.getData(currentPageCount);
      this.currentPage = currentPageCount;
    },
  },
};
</script>

<style lang="css" scoped>
.tab-title {
  @apply font-bold mb-1 text-24 leading-28;
}
.tab-toolbar {
  @apply flex justify-between items-center gap-x-20 sm:flex-col sm:gap-y-1.5;
}
</style>
